"use client"

import { useState } from "react"
import { HttpTypes } from "@medusajs/types"
import { Container } from "@medusajs/ui"
import Image from "next/image"

type ImageGalleryProps = {
  images: HttpTypes.StoreProductImage[]
}

const ImageGallery = ({ images }: ImageGalleryProps) => {
  const [activeImage, setActiveImage] = useState(0)

  if (!images || images.length === 0) {
    return null
  }

  const mainImage = images[activeImage]

  return (
    <div className="flex flex-col items-center w-full gap-4">

      <div className="flex gap-2 justify-center">
        {images.slice(0, 4).map((image, index) => (
          <div
            key={image.id}
            onClick={() => setActiveImage(index)}
            className={`relative w-16 h-16 cursor-pointer border rounded ${
              index === activeImage ? "border-black" : "border-gray-300"
            }`}
          >
            {image.url && (
              <Image
                src={image.url}
                alt={`Thumbnail ${index}`}
                fill
                sizes="64px"
                style={{ objectFit: "cover" }}
              />
            )}
          </div>
        ))}
      </div>

      <Container className="relative aspect-square w-full max-w-md mx-auto overflow-hidden bg-ui-bg-subtle">
        {mainImage?.url && (
          <Image
            src={mainImage.url}
            alt="Product main image"
            fill
            priority
            sizes="(max-width: 768px) 100vw, 800px"
            style={{ objectFit: "cover" }}
          />
        )}
      </Container>

    </div>
  )
}

export default ImageGallery
